import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PawPrint } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogPosts } from "@/hooks/use-blog-posts";
import AnimatedSection from "@/components/AnimatedSection";

export default function BlogSection() {
  const { posts } = useBlogPosts();
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white font-body">
      <AnimatedSection className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-16">
          <div className="space-y-4 text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start">
              <PawPrint
                className="w-6 h-6 md:w-8 md:h-8 text-accent shrink-0"
                fill="currentColor"
              />
              <h2 className="text-3xl md:text-4xl font-display font-bold text-primary uppercase">
                LATEST FROM THE BLOG
              </h2>
            </div>
            <p className="font-script text-4xl text-accent -rotate-1 origin-left inline-block">
              Helping real people with real dogs.
            </p>
          </div>
          <Button
            asChild
            variant="outline"
            className="w-full sm:w-auto border-2 border-primary text-primary font-bold px-4 sm:px-8 py-4 sm:py-6 h-auto whitespace-normal rounded-sm tracking-wide uppercase hover:bg-primary hover:text-white transition-all"
          >
            <Link to="/blog">BROWSE ALL ARTICLES</Link>
          </Button>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {posts.slice(0, 3).map((post, idx) => (
            <Card
              key={idx}
              className="overflow-hidden border-2 border-border/50 hover:shadow-md transition-all group cursor-pointer"
              onClick={() => navigate(`/blog/${post.slug}`)}
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  decoding="async"
                />
                <div className="absolute top-4 left-4 bg-accent text-white text-[10px] font-bold px-3 py-1 uppercase tracking-wider rounded-sm">
                  {post.category}
                </div>
              </div>
              <div className="p-6 space-y-3 text-center">
                <h3 className="text-xl font-bold text-primary leading-tight group-hover:text-accent transition-colors">
                  {post.title}
                </h3>
                <Button
                  variant="link"
                  className="p-0 h-auto text-accent font-bold uppercase tracking-widest text-xs"
                >
                  READ FULL ARTICLE
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </AnimatedSection>
    </section>
  );
}
